import { RouteObject } from 'react-router-dom'
import EquipesPage from '@/pages/equipes/EquipesPage'
import RankingPage from '@/pages/ranking/RankingPage'
import { SomenteBackoffice } from '../SomenteBackoffice'

/**
 * Rotas da AN-8 (Visão do Consultor, Onda 4 — DEV-P): equipes do gerente e ranking com
 * escopo. Ambas só do back-office (o consultor volta ao dashboard); dentro de cada página o
 * recorte por persona continua: Equipes = ADMIN (GERENTE+GESTOR_EQUIPE em leitura da
 * própria); Ranking = configuração para o back-office (ADMIN edita) e lista por consultor
 * para ADMIN e GERENTE+GESTOR_EQUIPE.
 */
const rotasAn8: RouteObject[] = [
  {
    path: 'equipes',
    element: (
      <SomenteBackoffice>
        <EquipesPage />
      </SomenteBackoffice>
    ),
  },
  {
    path: 'ranking',
    element: (
      <SomenteBackoffice>
        <RankingPage />
      </SomenteBackoffice>
    ),
  },
]

export default rotasAn8
